import React, { useEffect, useRef, useState } from "react";
import { Button, Card, Col, ConfigProvider, Form, Input, Row, Select, Tabs } from "antd";
import Table, { ColumnProps } from "antd/lib/table";
import { BarcodeOutlined, SearchOutlined, UndoOutlined } from '@ant-design/icons';
import Highlighter from 'react-highlight-words';

import moment from "moment";

import { useForm } from "antd/lib/form/Form";
import { Link } from 'react-router-dom';
import { CollectionsService, PurchasesProductService } from "@gtpl/shared-services/finance";
import { AlertMessages } from "@gtpl/shared-utils/alert-messages";
import { CollectionPaymentTypes } from "@gtpl/shared-models/common-models";
import { CollectionsFilters } from "@gtpl/shared-models/finance";
import { PortOfEntryCodes } from "@gtpl/shared-models/sale-management";





const { TabPane } = Tabs;

export function Collectionsview ()  {
    const [activeTab, setActiveTab] = useState("exportreceivables");

    const handleTabChange = (key) => {
        setActiveTab(key);
    };
    const [exportdata, setexportdata] =useState([]);
    const [exportdata1 ,setexportdata1] = useState([]);
    const [exportdata2 ,setexportdata2] = useState([]);
    const [igstdata2 ,setIgstdata] = useState([]);

    const [rodtepe , setrodtepe]=useState([]);
    const searchInput = useRef(null);
    const { Option } = Select;
    const [form ] = useForm()
    const [selectedEndCustomer, setSelectedEndCustomer]= useState<number>(0);
    const [endCustomers, setEndCustomers] = useState([])
    const [invData,setinvData] =useState([])
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
  const CollectionService = new CollectionsService()
  const [page, setPage] = React.useState(1);
  const [factoriesData, setFactoriesData] = useState([]);
  const purchaseService = new PurchasesProductService()




  const handleEndCustomer=(value) =>{
    console.log(value);
    setSelectedEndCustomer(value)
    getallDutyDetails() 
    getallDrawDetails()

  }


  const handleUnit =(value) =>{
    getallDrawDetails()
    getallDutyDetails()

  }

    const handleUnit1 =(value) =>{
    getallDrawDetails()
    getallDutyDetails()

  }
  
  

useEffect(()=>{
    getallDutyDetails() 
    getallDrawDetails()
    getActiveBuyerDropDownData()
    getActivateInvoicenum()
    getRodtepData()
    getIgstDetails()
    getAllCompanyNames()
},[])

const getActiveBuyerDropDownData = () => {
    CollectionService.getBuyerSDropDown().then((res) => {
      if (res.status) {
        setEndCustomers(res.data);
      } else {
        if (res.intlCode) {
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
        setEndCustomers([]);
      }
    })
      .catch((err) => {
        AlertMessages.getErrorMessage(err.message);
        setEndCustomers([]);
      });
  }
  

    const getAllCompanyNames = () => {
    purchaseService.getAllCompanys().then((res) => {
        if (res.status) {
            setFactoriesData(res.data)
        }
    })
}


  const getActivateInvoicenum = () => {
    CollectionService.getInvoiceNumber().then((res) => {
      if (res.status) {
        setinvData(res.data);
      } else {
        if (res.intlCode) {
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
        setinvData([]);
      }
    })
      .catch((err) => {
        AlertMessages.getErrorMessage(err.message);
        setinvData([]);
      });
  }

    const getallDutyDetails =() =>{
        const req =new CollectionsFilters()
        if(form.getFieldValue ("buyer")!=undefined){
        req.buyer= form.getFieldValue ("buyer")
        }
        if(form.getFieldValue("invNo")!=undefined){
            req.invNo = form.getFieldValue("invNo")
        }

         if(form.getFieldValue("unit")!=undefined){
            req.unitId = form.getFieldValue("unit")
        }

        CollectionService.getExportReceivablesData(req).then(res =>{
            if(res.status){
                setexportdata(res.data);
            }else{
                setexportdata([])
                // AlertMessages.getErrorMessage(res.internalMessage)
            }
            
        })
    }

    const getallDrawDetails=() =>{
        const req =new CollectionsFilters()
        if(form.getFieldValue ("buyer")!=undefined){
        req.buyer= form.getFieldValue ("buyer")
        }
        if(form.getFieldValue("invNo")!=undefined){
            req.invNo = form.getFieldValue("invNo")

        }
        if(form.getFieldValue("unit")!=undefined){
            req.unitId = form.getFieldValue("unit")
        }
        console.log(req,"========================")
        CollectionService.getDutyDrawBackData(req).then(res =>{
            if(res.status){
                setexportdata1(res.data);

            }else{
                setexportdata1([])
                // AlertMessages.getErrorMessage(res.internalMessage)
            }
        })
    }

    const getRodtepData =() =>{
        const req =new CollectionsFilters()
        if(form.getFieldValue ("buyer")!=undefined){
        req.buyer= form.getFieldValue ("buyer")
        }
        if(form.getFieldValue("invNo")!=undefined){
            req.invNo = form.getFieldValue("invNo")
        }
        CollectionService.getRodtepData(req).then(res =>{
            if(res.status){
                setexportdata2(res.data);
            }else{
                setexportdata2([])
                // AlertMessages.getErrorMessage(res.internalMessage)
            }
            
        })
    }
    const getIgstDetails=() =>{
        const req =new CollectionsFilters()
        if(form.getFieldValue ("buyer")!=undefined){
        req.buyer= form.getFieldValue ("buyer")
        }
        if(form.getFieldValue("invNo")!=undefined){
            req.invNo = form.getFieldValue("invNo")

        }
        console.log(req,"========================")
        CollectionService.getIgstData(req).then(res =>{
            if(res.status){
                setIgstdata(res.data);

            }else{
                setIgstdata([])
                // AlertMessages.getErrorMessage(res.internalMessage)
            }
        })
    }
    const handleBack = () => {
        // setModal(false)
      }
    
    
      function handleSearch(selectedKeys, confirm, dataIndex) {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
      };
    
      function handleReset(clearFilters) {
        clearFilters();
        setSearchText('');
      };


    const getColumnSearchProps = (dataIndex: string) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <div style={{ padding: 8 }}>
            <Input
              ref={searchInput}
              placeholder={`Search ${dataIndex}`}
              value={selectedKeys[0]}
              onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
              onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
              style={{ width: 188, marginBottom: 8, display: 'block' }}
            />
            <Button
              type="primary"
              onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
              icon={<SearchOutlined />}
              size="small"
              style={{ width: 90, marginRight: 8 }}
            >
              Search
            </Button>
            <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
              Reset
            </Button>
          </div>
        ),
        filterIcon: filtered => (
          <SearchOutlined type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
          record[dataIndex]
            ? record[dataIndex]
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase())
            : false,
        onFilterDropdownVisibleChange: visible => {
          if (visible) { setTimeout(() => searchInput.current.select()); }
        },
        render: text =>
          text ? (
            searchedColumn === dataIndex ? (
              <Highlighter
                highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                searchWords={[searchText]}
                autoEscape
                textToHighlight={text.toString()}
              />
            ) : text
          ) : null
      });

    const getRowSpan = (data: any[], index: number, keys: string[]) => {
        if (index === 0 || keys.some(key => {
            const currentVal = data[index][key];
            const prevVal = data[index - 1][key];
    
            if (key === 'etd' || key === 'eta') {
                const currentDate = currentVal ? moment(currentVal).format('YYYY-MM-DD') : null;
                const prevDate = prevVal ? moment(prevVal).format('YYYY-MM-DD') : null;
                return currentDate !== prevDate;
            }
    
            return String(currentVal).trim().toLowerCase() !== String(prevVal).trim().toLowerCase();
        })) {
            let rowSpan = 1;
            for (let i = index + 1; i < data.length; i++) {
                if (keys.every(key => {
                    const currentVal = data[i][key];
                    const originalVal = data[index][key];
    
                    if (key === 'etd' || key === 'eta') {
                        const currentDate = currentVal ? moment(currentVal).format('YYYY-MM-DD') : null;
                        const originalDate = originalVal ? moment(originalVal).format('YYYY-MM-DD') : null;
                        return currentDate === originalDate;
                    }
    
                    return String(currentVal).trim().toLowerCase() === String(originalVal).trim().toLowerCase();
                })) {
                    rowSpan++;
                } else {
                    break;
                }
            }
            return rowSpan;
        }

        return 0;
    };
    
    const getPortName = (portOfLoading) => {
          const portCode = PortOfEntryCodes.find((item) => Number(item.value) === Number(portOfLoading));
          return portCode ? portCode.name : portOfLoading;
        };



    const columnLine: ColumnProps<any>[] =[
        {
            title: 'S No',
            key: 'id',
            width: '70px',
            responsive: ['md'],
            align: 'left',
            render: (text, object, index) => (page-1) * 10 +(index+1)



        },

        {
            title: 'PO.NO',
            key: 'poNum',
            dataIndex: 'poNum',
            align: 'left',
            ...getColumnSearchProps('poNum'),
            sorter: (a, b) => a.poNum?.localeCompare(b.poNum),
            sortDirections: ['descend', 'ascend'],
            render: (_, record, index) => ({
                children: record.poNum,
                props: { rowSpan: getRowSpan(exportdata, index, ['poNum', 'invNum', 'etd', 'eta', 'endCustomerName', 'country','paymentTermsName']) }
            })
        },
        {
            title: 'INVOICE NO',
            key: 'invNum',
            dataIndex: 'invNum',
            align: 'left',
            ...getColumnSearchProps('invNum'),
            sorter: (a, b) => a.invNum?.localeCompare(b.invNum),
            sortDirections: ['descend', 'ascend'],
            render: (_, record, index) => ({
                children: record.invNum,
                props: { rowSpan: getRowSpan(exportdata, index, ['poNum', 'invNum', 'etd', 'eta', 'endCustomerName', 'country','paymentTermsName']) }
            })
        },
        {
            title: 'ETD',
            key: 'etd',
            dataIndex: 'etd',
            align: 'left',
            // ...getColumnSearchProps('etd'),
            sorter: (a, b) => a.etd?.localeCompare(b.etd),
            sortDirections: ['descend', 'ascend'],
            render: (_, record, index) => ({
                children: record.etd ? moment(record.etd).format("DD-MM-YYYY") : '-',
                props: { 
                    rowSpan: getRowSpan(exportdata, index, ['poNum', 'invNum', 'etd', 'eta', 'endCustomerName', 'country','paymentTermsName']) 
                }
            })
        },
        {
            title: 'ETA',
            key: 'eta',
            dataIndex: 'eta',
            align: 'left',
            // ...getColumnSearchProps('eta'),
            sorter: (a, b) => a.eta?.localeCompare(b.eta),
            sortDirections: ['descend', 'ascend'],
            render: (_, record, index) => ({
                children: record.eta ? moment(record.eta).format("DD-MM-YYYY") : '-',
                props: { 
                    rowSpan: getRowSpan(exportdata, index, ['poNum', 'invNum', 'etd', 'eta', 'endCustomerName', 'country','paymentTermsName']) 
                }
            })
        },
        {
            title: 'BUYER',
            key: 'endCustomerName',
            dataIndex: 'endCustomerName',
            align: 'left',
            ...getColumnSearchProps('endCustomerName'), 
            sorter: (a, b) => a.endCustomerName.localeCompare(b.endCustomerName), 
            sortDirections: ['descend', 'ascend'],
            render: (_, record, index) => ({
                children: record.endCustomerName,
                props: { rowSpan: getRowSpan(exportdata, index, ['poNum', 'invNum', 'etd', 'eta', 'endCustomerName', 'country','paymentTermsName']) }
            })
        },
        {
            title: 'Country Name',
            key: 'country',
            dataIndex: 'country',
            align: 'left',
            ...getColumnSearchProps('country'),
            render: (_, record, index) => ({
                children: record.country,
                props: { rowSpan: getRowSpan(exportdata, index, ['poNum', 'invNum', 'etd', 'eta', 'endCustomerName', 'country','paymentTermsName']) }
            })
        },
        
        {
            title: 'PAYMENT TERMS',
            key: 'paymentTermsName',
            dataIndex:'paymentTermsName',
            width: '140px',
            // responsive: ['md'],
            align: 'left',
            ...getColumnSearchProps('paymentTermsName'),
            sorter: (a, b) => a.paymentTermsName?.localeCompare(b.paymentTermsName),
            sortDirections: ['descend', 'ascend'],
            render: (_, record, index) => ({
                children: record.paymentTermsName,
                props: { rowSpan: getRowSpan(exportdata, index, ['poNum', 'invNum', 'etd', 'eta', 'endCustomerName', 'country','paymentTermsName']) }
            })


        },
        {
            title: 'BANK NAME',
            key: 'bankName',
            dataIndex: 'bankName',
            width: '130',
            responsive: ['md'],
            align: 'left',
            ...getColumnSearchProps('bankName'),
            // sorter:(a,b) => a.bankName.localeCompare(b.bankName),
            // sortDirections: ['descend', 'ascend']
            render: (text: any, record: any) => {
                return record?.transactions?.map((data, index) => {
                  let tag =data?.bankName &&  index !== record?.transactions.length -1  ? <hr style={{ marginTop: '0rem', marginBottom: '0rem' }}></hr> : <></>
                  return <>{data?.bankName} {tag}</>
        
                });
              },
        },
        
        {
            title: 'DUE DATE',
            key: 'dueDate',
            dataIndex: 'dueDate',
            width: '120',
            responsive: ['md'],
            align: 'left',
            ...getColumnSearchProps('dueDate'),
            sorter: (a, b) => a.dueDate - b.dueDate,
            sortDirections: ['descend', 'ascend'],
            render: (text: any, record: any) => {
                if (record?.transactions && record?.transactions.length > 0) {
                    return record?.transactions.map((data, index) => {
                        let tag =data?.dueDate &&  data?.dueDate && index !== record?.transactions.length - 1 ? 
                            <hr style={{ marginTop: '0rem', marginBottom: '0rem' }} /> : <></>;
        
                        return <>{data?.dueDate} {tag}</>;
                    });
                }
                return '-';
            },
        },
        
        
        {
            title: 'INVOICE VALUE IN USD',
            key: 'invAmt',
           dataIndex: 'invAmt',
            width: '70px',
            responsive: ['md'],
            align: 'left',
            ...getColumnSearchProps('invAmt'),
            sorter: (a, b) => a.invAmt-b.invAmt,
            sortDirections: ['descend', 'ascend'],
            render: (text: any, record: any) => {
                return record?.transactions?.map((data, index) => {
                  let tag =data?.invAmt &&  index !== record?.transactions.length -1  ? <hr style={{ marginTop: '0rem', marginBottom: '0rem' }}></hr> : <></>
                  return <>{data?.invAmt} {tag}</>
        
                });
              },

        },
        {
            title: 'TRANSACTION TYPE',
            key: 'transactionType',
            dataIndex: 'transactionType',
            width: '70px',
            responsive: ['md'],
            align: 'left',
            ...getColumnSearchProps('transactionType'),
            // sorter: (a, b) => a.transactionType.localeCompare(b.transactionType),
            // sortDirections: ['descend', 'ascend']
            render: (text: any, record: any) => {
                return record?.transactions?.map((data, index) => {
                  let tag =data?.transactionType &&  index !== record?.transactions.length -1  ? <hr style={{ marginTop: '0rem', marginBottom: '0rem' }}></hr> : <></>
                  return <>{data?.transactionType} {tag}</>
        
                });
              },

        },
        {
            title: 'RECEIVED DATE',
            key: 'recievedDate',
            dataIndex: 'recievedDate',
            width: '70px',
            responsive: ['md'],
            align: 'left',
            ...getColumnSearchProps('recievedDate'),
            sorter: (a, b) => a.recievedDate?.localeCompare(b.recievedDate),
            sortDirections: ['descend', 'ascend'],
            render: (text: any, record: any) => {
                return record?.transactions?.map((data, index) => {
                    const formattedReceivedDate = data?.recievedDate ? moment(data?.recievedDate).format('DD-MM-YYYY') : '';
                    let tag = formattedReceivedDate && index !== record?.transactions.length - 1 ? 
                        <hr style={{ marginTop: '0rem', marginBottom: '0rem' }} /> : <></>;
        
                    return <>{formattedReceivedDate} {tag}</>;
                });
            }


        },
        {
            title: 'RECEIVED AMOUNT IN USD',
            key: 'recievedAmt',
            dataIndex: 'recievedAmt',
            width: '70px',
            responsive: ['md'],
            align: 'left',
            ...getColumnSearchProps('recievedAmt'),
            sorter: (a, b) => a.recievedAmt-b.recievedAmt,
            sortDirections: ['descend', 'ascend'],
            render: (text: any, record: any) => {
                return record?.transactions?.map((data, index) => {
                  let tag =data?.recievedAmt &&  index !== record?.transactions.length -1  ? <hr style={{ marginTop: '0rem', marginBottom: '0rem' }}></hr> : <></>
                  return <>{data?.recievedAmt} {tag}</>
        
                });
              },


        },
        {
            title: 'Exchange Rate',
            key: 'exchangeRate',
           dataIndex: 'exchangeRate',
            width: '70px',
            responsive: ['md'],
            align: 'left',
            ...getColumnSearchProps('exchangeRate'),
            sorter: (a, b) => a.exchangeRate-b.exchangeRate,
            sortDirections: ['descend', 'ascend'],
            render: (text: any, record: any) => {
                return record?.transactions?.map((data, index) => {
                  let tag =data?.exchangeRate &&  index !== record?.transactions.length -1  ? <hr style={{ marginTop: '0rem', marginBottom: '0rem' }}></hr> : <></>
                  return <>{data?.exchangeRate} {tag}</>
        
                });
              },

        },
        {
            title: 'RECEIVED AMOUNT IN INR',
            key: 'receivedAmountInr',
           dataIndex: 'receivedAmountInr',
            width: '70px',
            responsive: ['md'],
            align: 'left',
            ...getColumnSearchProps('receivedAmountInr'),
            sorter: (a, b) => a.receivedAmountInr-b.receivedAmountInr,
            sortDirections: ['descend', 'ascend'],
            render: (text: any, record: any) => {
                return record?.transactions?.map((data, index) => {
                  let tag =data?.receivedAmountInr &&  index !== record?.transactions.length -1  ? <hr style={{ marginTop: '0rem', marginBottom: '0rem' }}></hr> : <></>
                  return <>{data?.receivedAmountInr} {tag}</>
        
                });
              },


        },
        {
            title: 'BANK CHARGES',
            key: 'bankCharges',
            dataIndex: 'bankCharges',
            width: '70px',
            responsive: ['md'],
            align: 'left',
            ...getColumnSearchProps('bankCharges'),
            sorter: (a, b) => a.bankCharges -b.bankCharges,
            sortDirections: ['descend', 'ascend'],
            render: (text: any, record: any) => {
                return record?.transactions?.map((data, index) => {
                  let tag =data?.bankCharges &&  index !== record?.transactions.length -1  ? <hr style={{ marginTop: '0rem', marginBottom: '0rem' }}></hr> : <></>
                  return <>{data?.bankCharges} {tag}</>
        
                });
              },

        },
        {
            title: 'BUYER SHORT PAYMENT',
            key: 'buyerShortPayment',
            dataIndex: 'buyerShortPayment',
            width: '70px',
            responsive: ['md'],
            align: 'left',
            // ...getColumnSearchProps('buyerShortpayment'),
            sorter: (a, b) => a.buyerShortpayment?.localeCompare(b.buyerShortPayment),
            sortDirections: ['descend', 'ascend'],
            render: (text: any, record: any) => {
                return record?.transactions?.map((data, index) => {
                  let tag =data?.buyerShortPayment &&  index !== record?.transactions.length -1  ? <hr style={{ marginTop: '0rem', marginBottom: '0rem' }}></hr> : <></>
                  return <>{data?.buyerShortPayment} {tag}</>
        
                });
              },

        },
        {
            title: 'TRANSACTION STATUS',
            key: 'transactionStatus',
            dataIndex: 'transactionStatus',
            width: '70px',
            responsive: ['md'],
            align: 'left',
            ...getColumnSearchProps('transactionStatus'),
            // sorter: (a, b) => a.transactionStatus-b.transactionStatus,
            // sortDirections: ['descend', 'ascend']
            render: (text: any, record: any) => {
                return record?.transactions?.map((data, index) => {
                  let tag =data?.transactionStatus &&  index !== record?.transactions.length -1  ? <hr style={{ marginTop: '0rem', marginBottom: '0rem' }}></hr> : <></>
                  return <>{data?.transactionStatus} {tag}</>
        
                });
              },

        },
        {
            title: 'REMARKS',
            key: 'remarks',
            dataIndex: 'remarks',
            width: '130px',
            responsive: ['md'],
            align: 'left',
            // ...getColumnSearchProps('remarks'), 
            // sorter: (a, b) => a.remarks-b.remarks, 
            // sortDirections: ['descend', 'ascend']
            render: (text: any, record: any) => {
                return record?.transactions?.map((data, index) => {
                  let tag =data?.remarks &&  index !== record?.transactions.length -1  ? <hr style={{ marginTop: '0rem', marginBottom: '0rem' }}></hr> : <></>
                  return <>{data?.remarks} {tag}</>
        
                });
              },
        }
        

    ]


    const columnLine1: ColumnProps<any>[] = [
        {
            title: 'S No',
            key: 'sno',
            width: '70px',
            responsive: ['md'],
            align: 'left',
            render: (text, object, index) => (page-1) * 10 +(index+1)



        },
        {
            title: 'INV.NO',
            key: 'invNum',
            dataIndex:'invNum',
            width: '150px',
            responsive: ['md'],
            align: 'left',
            ...getColumnSearchProps('invNum'),
            sorter: (a, b) => a.invNum?.localeCompare(b.invNum),
            sortDirections: ['descend', 'ascend']

        },
        {
            title: 'SHIPPING BILL NO',
            key: 'shippingBillNo',
            dataIndex:'shippingBillNo',
            width: '70px',
            responsive: ['md'],
            align: 'left',
            ...getColumnSearchProps('shippingBillNo'),
            sorter: (a, b) => a.shippingBillNo?.localeCompare(b.shippingBillNo),
            sortDirections: ['descend', 'ascend']


        },
        {
            title: 'SHIPPING BILL DATE',
            key: 'shippingBillDate',
            dataIndex:'shippingBillDate',
            width: '70px',
            responsive: ['md'],
            align: 'left',
            // ...getColumnSearchProps('shippingBillDate'),
            sorter: (a, b) => a.shippingBillDate?.localeCompare(b.shippingBillDate),
            sortDirections: ['descend', 'ascend'],
            render:(index,val) =>{
                return <span>{val.shippingBillDate?moment(val.shippingBillDate).format("DD-MM-YYYY"):'-'}</span>
            }

        },
        // {
        //     title: 'LEO DATE',
        //     key: 'leoDate',
        //     width: '70px',
        //     responsive: ['md'],
        //     align: 'left',
        //     ...getColumnSearchProps('leoDate'),
        //     sorter: (a, b) => a.leoDate-b.leoDate,
        //     sortDirections: ['descend', 'ascend'],
        //     render:(index,val) =>{
        //         return <span>{val.leoDate?moment(val.leoDate).format("DD-MM-YYYY"):'-'}</span>
        //     }
        // },

        // {
        //     title: 'BRC REL DATE AS PER S.B',
        //     key: 'brcRelDateasPerSb',
        //     width: '150',
        //     responsive: ['md'],
        //     align: 'left',
        //     ...getColumnSearchProps('brcRelDateasPerSb'),
        //     sorter: (a, b) => a.brcRelDateasPerSb-b.brcRelDateasPerSb,
        //     sortDirections: ['descend', 'ascend'],
        //     render: text => (text ?  text : '-'),

        // },
        // {
        //     title: 'SCROLL NO',
        //     key: 'scrollNo',
        //     dataIndex:'scrollNo',
        //     width: '70px',
        //     responsive: ['md'],
        //     align: 'left',
        //     ...getColumnSearchProps('scrollNo'),
        //     sorter: (a, b) => a.scrollNo?.localeCompare(b.scrollNo),
        //     sortDirections: ['descend', 'ascend']


        // },
        // {
        //     title: 'SCROLL DATE',
        //     key: 'scrollDate',
        //     dataIndex:'scrollDate',
        //     width: '70px',
        //     responsive: ['md'],
        //     align: 'left',
        //     // ...getColumnSearchProps('scrollDate'),
        //     sorter: (a, b) => a.scrollDate?.localeCompare(b.scrollDate),
        //     sortDirections: ['descend', 'ascend'],
        //     render:(index,val) =>{
        //         return <span>{val.scrollDate?moment(val.scrollDate).format("DD-MM-YYYY"):'-'}</span>
        //     }

        // },
        {
            title: 'FOB VALUE',
            key: 'fobvalue',
            dataIndex: 'fobvalue',
            width: '70px',
            responsive: ['md'],
            align: 'left',
            ...getColumnSearchProps('fobvalue'),
            sorter: (a, b) => a.fobvalue-b.fobvalue,
            sortDirections: ['descend', 'ascend'],
            render: text => (text ? text  : '-'),


        },
        {
            title: 'BUYER NAME',
            key: 'endCustomerName',
            dataIndex:'endCustomerName',
            width: '150px',
            responsive: ['md'],
            align: 'left',
            ...getColumnSearchProps('endCustomerName'),
            sorter: (a, b) => a.endCustomerName.localeCompare(b.endCustomerName),
            
            sortDirections: ['descend', 'ascend']

        },
        {
            title: 'CHA',
            key: 'cha',
            dataIndex:'cha',
            width: '70px',
            responsive: ['md'],
            align: 'left',
            ...getColumnSearchProps('cha'),
            sorter: (a, b) => a.cha?.localeCompare(b.cha),
            sortDirections: ['descend', 'ascend']

        },
        {
            title: 'PORT',
            key: 'portCode',
            dataIndex:'portCode',
            width: '70px',
            responsive: ['md'],
            align: 'left',
            ...getColumnSearchProps('portCode'),
            sorter: (a, b) => a.portCode-b.portCode,
            sortDirections: ['descend', 'ascend'],
            render: (text, record) => getPortName(record.portCode),

        },
        {
            title: 'Country Name',
            key: 'country',
            dataIndex: 'country',
            width: '70px',
            responsive: ['md'],
            align: 'left',
            ...getColumnSearchProps('country'),
             render: (text) => text ? text : '-',
         

        },
        {
            title: 'AMOUNT RECEIVABLE',
            key: 'invAmt',
            dataIndex:'invAmt',
            width: '70px',
            responsive: ['md'],
            align: 'left',
            ...getColumnSearchProps('invAmt'),
            sorter: (a, b) => a.invAmt-b.invAmt,
            sortDirections: ['descend', 'ascend']
        },
        {
            title: 'RECEIVED DATE',
            key: 'receivedDate',
            dataIndex:'receivedDate',
            width: '70px',
            responsive: ['md'],
            align: 'left',
            // ...getColumnSearchProps('receivedDate'),
            sorter: (a, b) => a.receivedDate.localeCompare(b.receivedDate),
            
            sortDirections: ['descend', 'ascend'],
            render:(index,val) =>{
                return <span>{val.receivedDate?moment(val.receivedDate).format("DD-MM-YYYY"):'-'}</span>
            }
        },
        // {
        //     title: 'RECEIVED AMOUNT',
        //     key: 'recievedAmt',
        //     dataIndex:'recievedAmt',
        //     width: '70px',
        //     responsive: ['md'],
        //     align: 'left',
        //     ...getColumnSearchProps('recievedAmt'),
        //     sorter: (a, b) => a.recievedAmt-b.recievedAmt,
        //     sortDirections: ['descend', 'ascend']
        // },
        // {
        //     title: 'Exchange Rate',
        //     key: 'exchangeRate',
        //    dataIndex: 'exchangeRate',
        //     width: '70px',
        //     responsive: ['md'],
        //     align: 'left',
        //     ...getColumnSearchProps('exchangeRate'),
        //     sorter: (a, b) => a.exchangeRate-b.exchangeRate,
        //     sortDirections: ['descend', 'ascend'],
        //     render: text => (text ? Number(text) : '-'),


        // },
        {
            title: 'RECEIVED AMOUNT IN INR',
            key: 'receivedAmountInr',
           dataIndex: 'receivedAmountInr',
            width: '70px',
            responsive: ['md'],
            align: 'left',
            ...getColumnSearchProps('receivedAmountInr'),
            sorter: (a, b) => a.receivedAmountInr-b.receivedAmountInr,
            sortDirections: ['descend', 'ascend'],
            render: text => (text ? Number(text) : '-'),


        },
        {
            title: 'Shipping Bill NO',
            key: 'shippingBillNo',
            dataIndex:'shippingBillNo',
            width: '90px',
            responsive: ['md'],
            align: 'left',
            sorter: (a, b) => a.shippingBillNo?.localeCompare(b.shippingBillNo),
            sortDirections: ['descend', 'ascend'],
            ...getColumnSearchProps('shippingBillNo'),
        },
        {
            title: 'Shipping Bill Date',
            key: 'shippingBillDate',
            dataIndex:'shippingBillDate',
            width: '120px',
            responsive: ['md'],
            align: 'left',
            // ...getColumnSearchProps('shippingBillDate'),
            sorter: (a, b) => a.shippingBillDate.localeCompare(b.shippingBillDate),
            
            sortDirections: ['descend', 'ascend'],
            render:(index,val) =>{
                return <span>{val.shippingBillDate?moment(val.shippingBillDate).format("DD-MM-YYYY"):'-'}</span>
            }
        },
        {
            title: 'Remarks',
            key: 'remarks',
            dataIndex: 'remarks',
            width: '130px',
            responsive: ['md'],
            align: 'left',
            render: text => (text ? Number(text) : '-'),

            // ...getColumnSearchProps('remarks'), 
            // sorter: (a, b) => a.remarks-b.remarks, 
            // sortDirections: ['descend', 'ascend']
        }
        

    ];

    const columnline2: ColumnProps<any>[] = [

        {
            title: 'S No',
            key: 'sno',
            width: '70px',
            responsive: ['md'],
            align: 'left',
            render: (text, object, index) => (page-1) * 10 +(index+1)



        },
        {
            title: 'INV.NO',
            key: 'invNum',
            dataIndex: 'invNum',
            width: '150px',
            responsive: ['md'],
            align: 'left',
            ...getColumnSearchProps('invNum'),
            sorter: (a, b) => a.invNum-b.invNum,
            sortDirections: ['descend', 'ascend']

        },
        {
            title: 'SHIPPING BILL NO',
            key: 'shippingBillNo',
            dataIndex: 'shippingBillNo',
            width: '70px',
            responsive: ['md'],
            align: 'left',
            ...getColumnSearchProps('shippingBillNo'),
            sorter: (a, b) => a.shippingBillNo-b.shippingBillNo,
            sortDirections: ['descend', 'ascend']


        },
        {
            title: 'SHIPPING BILL DATE',
            key: 'shippingBillDate',
            dataIndex: 'shippingBillDate',
            width: '70px',
            responsive: ['md'],
            align: 'left',
            ...getColumnSearchProps('shippingBillDate'),
            sorter: (a, b) => a.ShippingBillDate-b.shippingBillDate,
            sortDirections: ['descend', 'ascend'],
            render:(index,val) =>{
                return <span>{val.shippingBillDate?moment(val.shippingBillDate).format("DD-MM-YYYY"):'-'}</span>
            }

        },
        {
            title: 'LEO DATE',
            key: 'leoDate',
            dataIndex: 'leoDate',
            width: '70px',
            responsive: ['md'],
            align: 'left',
            ...getColumnSearchProps('leoDate'),
            sorter: (a, b) => a.leoDate-b.leoDate,
            sortDirections: ['descend', 'ascend'],
            render:(index,val) =>{
                return <span>{val.leoDate?moment(val.leoDate).format("DD-MM-YYYY"):'-'}</span>
            }
        },

        {
            title: 'BRC REL DATE AS PER S.B',
            key: 'brcDate', 
            dataIndex: 'brcDate',
            width: '70px',
            responsive: ['md'],
            align: 'left',
            ...getColumnSearchProps('brcDate'),
            sorter: (a, b) => a.brcDate-b.brcDate,
            sortDirections: ['descend', 'ascend'],
            render:(index,val) =>{

            return <span>{val.brcDate?moment(val.brcDate).format("DD-MM-YYYY"):'-'}</span>
            }

            
        },
        {
            title:'NET WEIGHT',
            key:'netweight',
            dataIndex:'netweight',
            width:'70px',
            responsive:['md'],
            align:'left',
            ...getColumnSearchProps('netWeight'),
            sorter: (a, b) => a.netWeight-b.netWeight,
            sortDirections: ['descend', 'ascend']
        },
        {
            title:'INV VALUE USD',
            key:'invAmt',
            dataIndex:'invAmt',
            width:'70px',
            responsive:['md'],
            align:'left',
            ...getColumnSearchProps('invAmt'),
            sorter: (a, b) => a.invAmt-b.invAmt,
            sortDirections: ['descend', 'ascend']
        },
        {
        title:'BRC VALUE IN USD',
            key:'brcValue',
            dataIndex:'brcValue',
            width:'70px',
            responsive:['md'],
            align:'left',
            ...getColumnSearchProps('brcValue'),
            sorter: (a, b) => (a.brcValue || '').localeCompare(b.brcValue || ''), // safer string comparison
            sortDirections: ['descend', 'ascend'],
        },
        {
            title:'DIFFERENCE',
            key:'difference',
            width:'70px',
            responsive:['md'],
            align:'left',
            ...getColumnSearchProps('difference'),
            sorter: (a, b) => a.difference-b.difference,
            sortDirections: ['descend', 'ascend'],
            render:(index,record) =>{

                return <span>{record.invAmt && record.brcValue? (record.invAmt - record.brcValue).toFixed(2):'-'}</span>
                }
        },
        {
            title: 'FOB VALUE',
            key: 'fobvalue',
            dataIndex: 'fobvalue',
            width: '70px',
            responsive: ['md'],
            align: 'left',
            ...getColumnSearchProps('fobValue'),
            sorter: (a, b) => (a.fobValue || '').localeCompare(b.fobValue || ''), // safer string comparison
            sortDirections: ['descend', 'ascend'],
        },
        {
            title: 'BUYER NAME',
            key: 'endCustomerName',
            dataIndex: 'endCustomerName',
            width: '150px',
            responsive: ['md'],
            align: 'left',
            ...getColumnSearchProps('endCustomerName'),
            sorter: (a, b) => (a.endCustomerName || '').localeCompare(b.endCustomerName || ''), // safer string comparison
            sortDirections: ['descend', 'ascend'],
        },
        {
            title: 'CHA',
            key: 'cha',
            dataIndex: 'cha',
            width: '70px',
            responsive: ['md'],
            align: 'left',
            ...getColumnSearchProps('cha'),
            sorter: (a, b) => (a.cha || '').localeCompare(b.cha || ''), // safer string comparison
            sortDirections: ['descend', 'ascend'],

        },

        {
            title: 'Country Name',
            key: 'country',
            width: '70px',
            responsive: ['md'],
            align: 'left',
            ...getColumnSearchProps('country'),
            render: text => (text ? text : '-'),
          

        },
        // {  
        //     title: 'BRC VALUE',
        // key: 'brcValue',
        // width: '70px',
        // responsive: ['md'],
        // align: 'left',
        // ...getColumnSearchProps('brcValue'),
        // sorter: (a, b) => a.brcvalue-b.brcValue,
        // sortDirections: ['descend', 'ascend']
        // },
        {
            title: 'RECIEVED RODTEP AMOUNT',
            key: 'receivedAmt',
            dataIndex: 'receivedAmt',
            width: '70px',
            responsive: ['md'],
            align: 'left',
            ...getColumnSearchProps('receivedAmt'),
            sorter: (a, b) => a.receivedAmt-b.receivedAmt,
            sortDirections: ['descend', 'ascend']

        },
        {
         title: 'LICENCE NO',
        key: 'lisenceNo',
        dataIndex: 'lisenceNo',
        width: '70px',
        responsive: ['md'],
        align: 'left',
        ...getColumnSearchProps('lisenceNo'),
        sorter: (a, b) => (a.lisenceNo || '').localeCompare(b.lisenceNo || ''), // safer string comparison
        sortDirections: ['descend', 'ascend'],
        // render:(index,val) =>{

        //     return <span>{val.lisenceNo?moment(val.lisenceNo):'-'}</span>
        //     }

        },
        {
        title: 'LICENCE DATE',
        key: 'liscenceDate',
        dataIndex: 'liscenceDate',
        width: '70px',
        responsive: ['md'],
        align: 'left',
        ...getColumnSearchProps('liscenceDate'),
        sorter: (a, b) => (a.liscenceDate || '').localeCompare(b.liscenceDate || ''), // safer string comparison
        sortDirections: ['descend', 'ascend'],
              render:(index,val) =>{
            return <span>{val.liscenceDate?moment(val.liscenceDate).format("DD-MM-YYYY"):'-'}</span>
        }
        },
        {
            title: 'INVOICE DATE',
            key: 'invoiceDate',
            dataIndex: 'invoiceDate',
            width: '70px',
            responsive: ['md'],
            align: 'left',
            sorter: (a, b) => (a.invoiceDate || '').localeCompare(b.invoiceDate || ''), // safer string comparison
        sortDirections: ['descend', 'ascend'],
            render:(index,val) =>{
                return <span>{val.invoiceDate?moment(val.invoiceDate).format("DD-MM-YYYY"):'-'}</span>
            }

        },
        {
            title: 'CUSTOMER',
            key: 'customer',
            dataIndex: 'customer',
            width: '70px',
            responsive: ['md'],
            align: 'left',
            sorter: (a, b) => (a.customer || '').localeCompare(b.customer || ''), // safer string comparison
            sortDirections: ['descend', 'ascend'],
            ...getColumnSearchProps('customer'),

        },
        {
            title: 'SALE AMOUNT',
            key: 'saleAmount',
            dataIndex: 'saleAmount',
            width: '70px',
            responsive: ['md'],
            align: 'left',
            sorter: (a, b) => a.saleAmount-b.saleAmount,
            sortDirections: ['descend', 'ascend'],
        },
        {
            title: 'DISCOUNT RATE ',
            key: 'discountRate',
            dataIndex: 'discountRate',
            width: '70px',
            responsive: ['md'],
            align: 'left',
            sorter: (a, b) => a.discountRate-b.discountRate,
            sortDirections: ['descend', 'ascend'],
        },
        {
            title: 'FINAL SALE AMOUNT',
            key: 'finalSaleAmount',
            dataIndex: 'finalSaleAmount',
            width: '70px',
            responsive: ['md'],
            align: 'left',
            sorter: (a, b) => a.finalSaleAmount-b.finalSaleAmount,
        sortDirections: ['descend', 'ascend'],
        },
        {
            title: 'REMARKS',
            key: 'remarks',
            width: '70px',
            responsive: ['md'],
            align: 'left',
            // ...getColumnSearchProps('remarks'),
            // sorter: (a, b) => a.remarks-b.remarks,
            // sortDirections: ['descend', 'ascend']

        }

    ]

    const igstColumns: ColumnProps<any>[] = [
        {
            title: 'S No',
            key: 'sno',
            width: '70px',
            responsive: ['md'],
            align: 'left',
            render: (text, object, index) => (page-1) * 10 +(index+1)



        },
        {
            title: 'INV.NO',
            key: 'invNum',
            dataIndex:'invNum',
            width: '150px',
            responsive: ['md'],
            align: 'left',
            ...getColumnSearchProps('invNum'),
            sorter: (a, b) => a.invNum?.localeCompare(b.invNum),
            sortDirections: ['descend', 'ascend']

        },
        {
            title: 'SHIPPING BILL NO',
            key: 'shippingBillNo',
            dataIndex:'shippingBillNo',
            width: '70px',
            responsive: ['md'],
            align: 'left',
            ...getColumnSearchProps('shippingBillNo'),
            sorter: (a, b) => a.shippingBillNo?.localeCompare(b.shippingBillNo),
            sortDirections: ['descend', 'ascend']


        },
        {
            title: 'SHIPPING BILL DATE',
            key: 'shippingBillDate',
            dataIndex:'shippingBillDate',
            width: '70px',
            responsive: ['md'],
            align: 'left',
            // ...getColumnSearchProps('shippingBillDate'),
            sorter: (a, b) => a.shippingBillDate?.localeCompare(b.shippingBillDate),
            sortDirections: ['descend', 'ascend'],
            render:(index,val) =>{
                return <span>{val.shippingBillDate?moment(val.shippingBillDate).format("DD-MM-YYYY"):'-'}</span>
            }

        },
        {
            title: 'LEO DATE',
            key: 'leoDate',
            width: '70px',
            responsive: ['md'],
            align: 'left',
            ...getColumnSearchProps('leoDate'),
            sorter: (a, b) => a.leoDate-b.leoDate,
            sortDirections: ['descend', 'ascend'],
            render:(index,val) =>{
                return <span>{val.leoDate?moment(val.leoDate).format("DD-MM-YYYY"):'-'}</span>
            }
        },

        // {
        //     title: 'BRC REL DATE AS PER S.B',
        //     key: 'brcRelDateasPerSb',
        //     width: '150',
        //     responsive: ['md'],
        //     align: 'left',
        //     ...getColumnSearchProps('brcRelDateasPerSb'),
        //     sorter: (a, b) => a.brcRelDateasPerSb-b.brcRelDateasPerSb,
        //     sortDirections: ['descend', 'ascend'],
        //     render: text => (text ?  text : '-'),

        // },
       
        {
            title: 'BUYER NAME',
            key: 'endCustomerName',
            dataIndex:'endCustomerName',
            width: '150px',
            responsive: ['md'],
            align: 'left',
            ...getColumnSearchProps('endCustomerName'),
            sorter: (a, b) => a.endCustomerName.localeCompare(b.endCustomerName),
            
            sortDirections: ['descend', 'ascend']

        },
       
        {
            title: 'PORT',
            key: 'portCode',
            dataIndex:'portCode',
            width: '70px',
            responsive: ['md'],
            align: 'left',
            ...getColumnSearchProps('portCode'),
            sorter: (a, b) => a.portCode-b.portCode,
            sortDirections: ['descend', 'ascend'],
            render: (text, record) => getPortName(record.portCode),

        },
        {
            title: 'Country Name',
            key: 'country',
            dataIndex: 'country',
            width: '70px',
            responsive: ['md'],
            align: 'left',
            ...getColumnSearchProps('country'),
             render: (text) => text ? text : '-',
         

        },
        {
            title: 'AMOUNT RECEIVABLE',
            key: 'tax',
            dataIndex:'tax',
            width: '70px',
            responsive: ['md'],
            align: 'left',
            ...getColumnSearchProps('tax'),
            sorter: (a, b) => a.tax-b.tax,
            sortDirections: ['descend', 'ascend']
        },
        {
            title: 'RECEIVED DATE',
            key: 'receivedDate',
            dataIndex:'receivedDate',
            width: '70px',
            responsive: ['md'],
            align: 'left',
            // ...getColumnSearchProps('receivedDate'),
            sorter: (a, b) => a.receivedDate.localeCompare(b.receivedDate),
            
            sortDirections: ['descend', 'ascend'],
            render:(index,val) =>{
                return <span>{val.receivedDate?moment(val.receivedDate).format("DD-MM-YYYY"):'-'}</span>
            }
        },
        
       
        {
            title: 'RECEIVED AMOUNT IN INR',
            key: 'receivedAmountInr',
           dataIndex: 'receivedAmountInr',
            width: '70px',
            responsive: ['md'],
            align: 'left',
            ...getColumnSearchProps('receivedAmountInr'),
            sorter: (a, b) => a.receivedAmountInr-b.receivedAmountInr,
            sortDirections: ['descend', 'ascend'],
            render: text => (text ? Number(text) : '-'),


        },
        {
            title: 'Shipping Bill NO',
            key: 'shippingBillNo',
            dataIndex:'shippingBillNo',
            width: '90px',
            responsive: ['md'],
            align: 'left',
            sorter: (a, b) => a.shippingBillNo?.localeCompare(b.shippingBillNo),
            sortDirections: ['descend', 'ascend'],
            ...getColumnSearchProps('shippingBillNo'),
        },
        {
            title: 'Shipping Bill Date',
            key: 'shippingBillDate',
            dataIndex:'shippingBillDate',
            width: '120px',
            responsive: ['md'],
            align: 'left',
            // ...getColumnSearchProps('shippingBillDate'),
            sorter: (a, b) => a.shippingBillDate.localeCompare(b.shippingBillDate),
            
            sortDirections: ['descend', 'ascend'],
            render:(index,val) =>{
                return <span>{val.shippingBillDate?moment(val.shippingBillDate).format("DD-MM-YYYY"):'-'}</span>
            }
        },
       
        

    ];

    return (
        <>
            <Card  size="small" title={<span style={{ color: 'white' }} >Collections</span>}
            style={{ textAlign: 'center' }} headStyle={{ backgroundColor: '#69c0ff', border: 0 }}
            extra={
              <Link to="/collections">
                <Button className="panel_button">Create </Button>
              </Link>
            }            >
    <Form form={form} layout="vertical">
    <Row gutter={24}>
           <Col xs={{span:24}} sm={{span:24}} md={{span:6}} lg={{span:5}} xl={{span:5}}>
<Form.Item name="unit" label="Unit" rules={[{ required: false }]}>
                    <Select
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                        placeholder=" Select Unit"
                        onChange={handleUnit1}
                        allowClear
                        dropdownMatchSelectWidth={false}
                    >
                         {factoriesData.map(dropData => {
                            console.log(factoriesData,'factoriesDatafactoriesDatafactoriesData')
                            return <Option value={dropData.companyId}>{dropData.company}</Option>
                        })}
                    </Select>
                    </Form.Item>



                    </Col >
    <Col xs={{span:24}} sm={{span:24}} md={{span:6}} lg={{span:5}} xl={{span:5}}>
<Form.Item name="buyer" label="Buyer Name" rules={[{ required: false }]}>
                    <Select
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                        placeholder=" Select Buyer Name"
                        onChange={handleEndCustomer}
                        allowClear
                        dropdownMatchSelectWidth={false}
                    >
                      {/* <Option key={0} value={null}>Select All End Customer</Option> */}
                      {endCustomers?endCustomers.map(endCust => {
                      return <Option key={endCust.buyerId}  value={endCust.buyerId}>{endCust.buyerName}</Option>
                    }):""} 

                    </Select>
                    </Form.Item>



                    </Col >

                    <Col xs={{span:24}} sm={{span:24}} md={{span:6}} lg={{span:5}} xl={{span:5}}>
                <Form.Item name="invNo" label="Invoice Number" rules={[{ required: false }]}>
                    <Select
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                        placeholder="Select Invoice Number"
                        onChange={handleUnit}
                        allowClear
                    >
                      {/* <Option key={0} value={null}>Select Unit</Option> */}
                      {invData?invData.map(plant => {
                      return <Option key={plant.invNum}  value={plant.invNum}>{plant.invNum}</Option>
                    }):""}

                    </Select>
                </Form.Item>
                
              </Col>
              </Row>
              </Form>
                    

        <Row gutter={24}>
        <Col>
  
</Col>
        </Row>
        <ConfigProvider ></ConfigProvider>



       
        
        <Tabs type={'card'} tabPosition={'top'}>

        <TabPane 
            key = "2"
            tab={<span style={{ color: "green" }}> {CollectionPaymentTypes.EXPORT_RECEIVABLES} {`: ${exportdata?.length}` }</span>}
            >
                <Table
                columns={columnLine}
                dataSource={exportdata}
                scroll={{ x:'max-content' }}
                pagination={{
                    onChange(current) {
                     setPage(current);
                     
                    
                }}}
                ></Table>
               
            </TabPane>


             <TabPane
              key="1"
              tab={<span style={{ color: "green" }}>{CollectionPaymentTypes.DUTY_DRAW_BACK} {`: ${exportdata1?.length}`}</span>}
            >
                <Table
                columns={columnLine1}
                dataSource={exportdata1}
                scroll={{ x: 'max-content'}}
                pagination={{
                    onChange(current) {
                     setPage(current);
                     
                    
                }}}/>
                    
            </TabPane>


           



            <TabPane 
            key ="3"
             tab={<span style={{ color: "green" }}> {CollectionPaymentTypes.RODTEP} {`: ${exportdata2?.length}`}</span>}>

                <Table
                columns={columnline2}
                dataSource={exportdata2}
                scroll={{ x: true }}
                pagination={{
                    onChange(current) {
                      setPage(current);
                    }
                }}/>
                
                
            </TabPane>
            <TabPane 
            key ="4"
             tab={<span style={{ color: "green" }}> {CollectionPaymentTypes.IGST} {`: ${igstdata2?.length}`}</span>}>

                <Table
                columns={igstColumns}
                dataSource={igstdata2}
                scroll={{ x: true }}
                pagination={{
                    onChange(current) {
                      setPage(current);
                    }
                }}/>
                
                
            </TabPane>
        </Tabs>
        </Card>
        </>
    );
};

export default  Collectionsview;




